module.exports = __webpack_public_path__ + "img/homeA.b0dbe371.png";